import script from "./NewPostCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewPostCard.vue?vue&type=script&setup=true&lang=ts"

import "./NewPostCard.vue?vue&type=style&index=0&id=76c27159&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c27159"]])

export default __exports__